export enum TicketMode {
  MyTickets = 'my_tickets',
  AssignedToMyGroups = 'assigned_to_my_groups',
  All = 'all',
}
